

// 根据当前域名判断当前语言
export const checkLang = (): "en" | "ch" | "russia" => {
    const domainMap: Record<string, "en" | "ch" | "russia"> = {
        "shengao.local": "en",
        "ch.example.com": "ch",
        "www.example.com": "russia",
    };

    const hostname = window.location.hostname;

    const lang = domainMap[hostname];

    if (lang) {
        return lang;
    }

    console.error(`[checkLang] 未匹配到对应域名: ${hostname}`);

    return "en";
};

/**
 * 执行页面传入的异步初始化动作。
 * 执行完传来的初始动作后, 为body添加 ready 类，让页面显示出来。
 */
export const initPageWithAnimation = async (init: () => Promise<void> = async () => {}) => {
    const header = document.querySelector<HTMLElement>("body > div.header");

    if (header) {
        // 强制设置成特定高度
        document.body.style.setProperty(
            "padding-top",
            `${header.offsetHeight}px`,
            "important"
        );
    }

    await init();
};

/**
 * 根据 AI 页面视图切换 WordPress 公共 Header。
 * Vite 独立开发环境没有该元素，此时不修改页面布局并直接返回。
 */
export const syncWordPressHeader = (show: boolean) => {
    const header = document.querySelector<HTMLElement>("body > div.header");
    if (!header) return;

    if (!show) {
        header.style.setProperty("display", "none", "important");
        document.body.style.setProperty("padding-top", "0", "important");
        return;
    }

    header.style.removeProperty("display");
    document.body.style.setProperty(
        "padding-top",
        `${header.offsetHeight}px`,
        "important"
    );
};

// 生成版本号(每20分钟强制更新一次)
export const getVersionMin20 = (): string => {
  const now = new Date();

  const minutes = Math.floor(now.getMinutes() / 20) * 20;

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(minutes).padStart(2, "0");

  return `${year}${month}${day}-${hour}${minute}`;
};
